/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerFindAllTasksQueryResponse, ApplicationsControllerFindAllTasksPathParams, ApplicationsControllerFindAllTasksQueryParams, ApplicationsControllerFindAllTasks401, ApplicationsControllerFindAllTasks403, ApplicationsControllerFindAllTasks404 } from "../../models/checklistsController/ApplicationsControllerFindAllTasks";

function getApplicationsControllerFindAllTasksUrl(id: ApplicationsControllerFindAllTasksPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-applications/${id}/tasks` as const }  
  return res
}

/**
 * @summary List tasks linked to a checklist application
 * {@link /api/v1/checklist-applications/:id/tasks}
 */
export async function applicationsControllerFindAllTasks(id: ApplicationsControllerFindAllTasksPathParams["id"], params?: ApplicationsControllerFindAllTasksQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationsControllerFindAllTasksQueryResponse, ResponseErrorConfig<ApplicationsControllerFindAllTasks401 | ApplicationsControllerFindAllTasks403 | ApplicationsControllerFindAllTasks404>, unknown>({ method : "GET", url : getApplicationsControllerFindAllTasksUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}